import React, { useEffect, useState } from "react";
import personeAvatar from "../../../assets/imgs/randomPerson.avif";
import "../../../assets/css/students.css";
import { Avatar, Grid } from "@mui/material";
import { Link } from "react-router-dom";
import { useGetStudentsListQuery } from "../../../redux/features/parentPortal/students/studentsApi";
import { useSelector } from "react-redux";
import { getProfileAvatarFromName } from "../../../utils/helpers";
import { deepPurple } from "@mui/material/colors";
import { capitalizeWords } from "../../../hooks/HelperFunctions";
import FiberManualRecordIcon from "@mui/icons-material/FiberManualRecord";

const StudentsListing = () => {
  const user = useSelector((state) => state.auth.user);
  const [students, setStudents] = useState([]);
  const { data, isLoading, isError } = useGetStudentsListQuery(user?._id, {
    refetchOnMountOrArgChange: true,
  });

  useEffect(() => {
    if (data && !isError && !isLoading) {
      setStudents(data?.body?.data);
    }
  }, [data, isLoading, isError]);

  return (
    <div>
      <Grid container>
        {/* ------------ card one --------------- */}
        {students?.map((item) => (
          <Grid item lg={4} md={6} sm={12}>
            <Link
              to={`/students-details/${item?._id}`}
              className="studentCardLink"
            >
              <div className="studentCardContainer">
                <Avatar
                  alt={item?.firstName}
                  src={
                    item?.idPicture
                      ? item?.idPicture
                      : getProfileAvatarFromName(item?.firstName)
                  }
                ></Avatar>
                <div>
                  <div className="flexedCentered StudentListingCardContainer">
                    <h2>
                      {/* {item?.firstName} {item?.lastName} */}
                      {`${
                        (item?.firstName + " " + item?.lastName).length > 20
                          ? (item?.firstName + " " + item?.lastName).slice(
                              0,
                              20
                            ) + "..."
                          : item?.firstName + " " + item?.lastName
                      }`}
                    </h2>

                    <span
                      className="status rounded statussmall"
                      style={{
                        // marginLeft: item.space,
                        background:
                          item.status === "inactive" ? "#FCE7E9" : "#E1F2E8",
                        color:
                          item.status === "inactive" ? "#E63946" : "#0B9444",
                        // display: item.align,
                        // width: item.StatusWidth,
                      }}
                    >
                      <div
                        className="StatusLine"
                        style={{
                          background:
                            item.status === "inactive" ? "#BA1A1A" : "#41AB37",
                        }}
                      ></div>
                      {capitalizeWords(item?.status)}
                    </span>
                    {/* <span className="">
                      <FiberManualRecordIcon fontSize="small" />
                    </span> */}
                  </div>
                  <p>
                    {item?.schoolName.length > 20
                      ? item?.schoolName.slice(0, 20) + "..."
                      : item?.schoolName}
                  </p>
                </div>
              </div>
            </Link>
          </Grid>
        ))}
      </Grid>
    </div>
  );
};

export default StudentsListing;
